import React, { useRef, useEffect } from "react";
import RoundedButton from "../Buttons/RoundedButton";
import classes from "./ModalReceiveGoal.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import congratulations from "../../assets/images/congratulations.svg";
import { useNavigate } from "react-router-dom";
import * as kRoutes from "../../constants/routes";
import ConfettiCelebration from "../ConfettiCelebration";
import useGoalCelebration from "../../hooks/useGoalCelebration";

const ModalReceiveGoal = ({
  openModal,
  setOpenModal,
  setVerifyButtons,
  callMedals,
  diaDaSemana,
  GoalPeriodicity,
  coinsReceived,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const wrapperRef = useRef(null);
  const { isCelebrating, startCelebration } = useGoalCelebration();

  useEffect(() => {
    if (openModal) {
      startCelebration();
    }
  }, [openModal, startCelebration]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setVerifyButtons(true);
        setOpenModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpenModal, setVerifyButtons]);

  const handleClose = () => {
    setOpenModal(false);
    setVerifyButtons(true);
  };

  const handleGoToStore = () => {
    setOpenModal(false);
    navigate(kRoutes.R_COINSTORE);
  };

  if (!openModal) return null;

  return (
    <div className={classes.Modal} ref={wrapperRef}>
      <ConfettiCelebration active={isCelebrating} />

      <div className={classes.ModalHeader}>
        <button className={classes.BtnClose} onClick={handleClose} />
      </div>

      <div className={classes.ModalContent}>
        <div className={classes.RewardGoalWin}>
          <img
            src={congratulations}
            alt=""
            className={classes.GoalWinImg}
          />
        </div>

        <div className={classes.TextArea} style={{marginBottom: "10px"}}>
          <div className={classes.TextAreaCoins}>
            {t("global.congrats_goal_coins").replace("XX", coinsReceived)}
          </div>
          <div className={classes.PulseRescued}>
            {t("global.rescued") || "Resgatou"}
          </div>
          <div className={classes.TextAreaMessage}>
            {t("global.exchange_for_items_from_the_tuning_collection")}
          </div>
        </div>

        <div className={classes.ButtonsArea}>
          <RoundedButton
            text={t("global.close")}
            onClick={handleClose}
            className={classes.ButtonsAreaClose}
          />
          <RoundedButton
            text={t("global.view_items")}
            onClick={handleGoToStore}
          />
        </div>
      </div>
    </div>
  );
};

export default ModalReceiveGoal;
